import React, { useState, useMemo } from 'react';
import Slider from "react-slick";
import SLIDE_DATA from './SLIDE_DATA';
import styles from './index.module.scss';
import { Link } from 'react-router-dom';

function TutorialSlide({ isMemberLogin }) {
    const [currentSlide, setCurrentSlide] = useState(0);
    const stepButtonsActiveClass = useMemo(() => {
        const MAP = {
            0: styles.stepButtonActive1,
            1: styles.stepButtonActive2,
            2: styles.stepButtonActive3,
        }
        return MAP[currentSlide];
    }, [currentSlide]);

    
    return (
        <div className={styles.tutorialSlide}>
            <div className={styles.wrapper}>
                <div className={styles.stepWrapper}>
                    <p>步驟</p>
                    <div
                        className={`${styles.stepButtons} ${stepButtonsActiveClass}`}
                    >
                        <button
                            className={styles.stepButton1}
                            onClick={() => setCurrentSlide(0)}
                        >
                            01
                        </button>
                        <button
                            className={styles.stepButton2}
                            onClick={() => setCurrentSlide(1)}
                        >
                            02
                        </button>
                        <button
                            className={styles.stepButton3}
                            onClick={() => setCurrentSlide(2)}
                        >
                            03
                        </button>
                    </div>
                </div>
                <div className={styles.contentWrapper}>
                    <h3>{SLIDE_DATA[currentSlide].title}</h3>
                    <p>{SLIDE_DATA[currentSlide].text}</p>
                    <div className={styles.videoWrapper}>
                        <video src={SLIDE_DATA[currentSlide].video} muted autoPlay controls playsInline />
                    </div>
                </div>
                <div className={styles.buttonWrapper}>
                <div>
                    {currentSlide > 0 && (
                        <button
                            className={styles.prevButton}
                            onClick={() =>
                                setCurrentSlide(currentSlide - 1)
                            }
                        >
                            上一步
                        </button>
                    )}
                    {currentSlide < SLIDE_DATA.length - 1 && (
                        <button
                            className={styles.nextButton}
                            onClick={() =>
                                setCurrentSlide(currentSlide + 1)
                            }
                        >
                            下一步
                        </button>
                    )}
                    {currentSlide === SLIDE_DATA.length - 1 && isMemberLogin && (
                        <Link
                            className={styles.nextButton}
                            to="/statistics/ChishangEarthquake/custom-data"
                        >
                            開始製作圖表
                        </Link>
                    )}
                </div>
                {isMemberLogin && (
                    <Link
                        to="/statistics/ChishangEarthquake/custom-data"
                    >
                        跳過教學
                    </Link>
                )}
            </div>
            </div>
        </div>
    );
}

export default TutorialSlide;